import ErrorBoundary from '../../components/ErrorBoundary';
import ContentfulPage from '../../components/contentfulPage';
import { createRoot } from 'react-dom/client';

interface ContentfulStartupParams {
    containerId: string;
    entryId: string;
}

const contentfulStartup = ({ containerId, entryId }: ContentfulStartupParams) => {
    const container = document.getElementById(containerId);
    if (container) {
        const root = createRoot(container);
        root.render(
            <ErrorBoundary>
                <ContentfulPage entryId={entryId} />
            </ErrorBoundary>,
        );
    }
};

export default contentfulStartup;
